import { createContext, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Axios from '../axios';
import * as actionTypes from "../store/Actions/actions";

const LocalesContext = createContext();

const languagesList = [
    { value: "en", text: "English" },
    { value: "es", text: "Spanish" },
    { value: "fr", text: "French" }
];

const defaultLocale = "en";

const LocalesProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { layoutTitle, layoutList, layoutLanguages } = useSelector(state => state.present);
    const [messages, setMessages] = useState({});
    const [currentLocale, setCurrentLocale] = useState(defaultLocale);

    const onError = () => {
        //error
    }

    useEffect(() => {
        Axios.MediaService.GET_DICTIONARY()
            .then(res => {
                setMessages(res.data);
            })
            .catch(_ => {
                onError();
            })
    }, [])

    useEffect(() => {
        if(layoutLanguages){
            const selectedLayoutIndex = layoutList.findIndex(item => item[0] === layoutTitle);
            changeLocale(selectedLayoutIndex)
        } else {            
          const newLayoutLanguages = layoutList.map(() => "en");
          dispatch(actionTypes.set_layout_languages(newLayoutLanguages))
        }
    }, [layoutLanguages])


    const changeLocale = (index) => {
        setCurrentLocale(layoutLanguages[index])
    }


    return (
        <LocalesContext.Provider value={{ messages, currentLocale, defaultLocale, changeLocale, languagesList }}>
            <IntlProvider locale={currentLocale} messages={messages[currentLocale]} onError={onError}>
                {children}
            </IntlProvider>
        </LocalesContext.Provider>
    );
};

export { LocalesContext, LocalesProvider };